/*
 *---------------------------------------------------
 * Licensed Materials - Property of HCL Technologies
 *
 * HCL Commerce
 *
 * (C) Copyright HCL Technologies Limited 2021
 *
 *---------------------------------------------------
 */
import React, { createContext, useContext, useEffect, useState } from "react";
import { localStorageHelper } from "../helpers/storageHelper";
import { useCSRValue } from "./csr-context";

export const SelectedStoreContext: React.Context<any> = createContext(null);
export const SelectedStoreProvider = ({ children }: any) => {
  const [selectedStore, setSelectedStore] = useState(null);
  const { csr } = useCSRValue();

  useEffect(() => {
    if (!csr.userLoggedIn) {
      setSelectedStore(null);
    }

    if (csr.userLoggedIn) {
      if (!selectedStore) {
        const savedStore = localStorageHelper.get("CURRENT-STORE");
        if (savedStore) {
          setSelectedStore(savedStore);
        }
      }
    }
  }, [csr]);

  return (
    <SelectedStoreContext.Provider value={{ selectedStore, setSelectedStore }}>
      {children}
    </SelectedStoreContext.Provider>
  );
};

export const useSelectedStoreValue = () => useContext(SelectedStoreContext);
